var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 223,
    viewBox: "0 0 222 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.234 154.184H88.3097V169.929H105.234V154.184Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7341 154.184H56.8099V169.929H73.7341V154.184Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.219 111.415H120.123C115.146 111.415 111.118 115.443 111.118 120.42V154.574H158.228L129.382 125.728L139.651 115.46L186.099 161.908L139.651 208.357L129.382 198.088L158.228 169.243H111.118V205.516C111.118 210.493 115.146 214.521 120.123 214.521H205.219C210.197 214.521 214.224 210.493 214.224 205.516V120.42C214.224 115.443 210.197 111.415 205.219 111.415Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.706 50.866H115.782V66.6117H132.706V50.866Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.198 50.866H147.273V66.6117H164.198V50.866Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.884 6.27452H15.7881C10.8108 6.27452 6.78326 10.3021 6.78326 15.2793V100.375C6.78326 105.353 10.8108 109.38 15.7881 109.38H100.884C105.861 109.38 109.889 105.353 109.889 100.375V66.2217H62.7792L91.625 95.0675L81.3568 105.336L34.9084 58.8873L81.3568 12.4473L91.625 22.7155L62.7792 51.5613H109.889V15.2793C109.889 10.3021 105.861 6.27452 100.884 6.27452Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.5127c0fc97e0d9452aebfef523ccae00.svg";
export { ForwardRef as ReactComponent };